import React from "react";
import { severityClass, formatSeverity } from "../utils";
import { useLanguage } from "@/i18n/LanguageContext";

export const Th: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <th className="sticky top-0 z-10 bg-slate-50 px-1.5 py-1 text-[10px] font-semibold">{children}</th>
);

export const Td: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <td className="px-1.5 py-1 text-[10px] text-slate-700">{children}</td>
);

export const Severity: React.FC<{ value?: string }> = ({ value }) => {
  const { t } = useLanguage();
  return (
    <td className="px-1.5 py-1">
      <span className={`rounded-full border px-1.5 py-0.5 text-[9px] ${severityClass(value)}`}>
        {value ? formatSeverity(value, t) : t("common.empty")}
      </span>
    </td>
  );
};

export const EmptyRow: React.FC<{ colSpan: number; loading: boolean }> = ({ colSpan, loading }) => {
  const { t } = useLanguage();
  return (
    <tr>
      <td colSpan={colSpan} className="px-2.5 py-3 text-center text-xs text-slate-500">
        {loading ? t("common.loading") : t("common.noRows")}
      </td>
    </tr>
  );
};
